module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/sorority-custom-apparel-medium-430242a4447c191baf5863279a23a4d4.jpg";